export const meta = {
  title: '隐私政策 | Hotel Lobby AI',
  description:
    'Hotel Lobby AI 如何处理您的照片、生成的视频、账户、支付和使用信息。',
  updated_at: '2026-10-03',
};

## 关于本政策

Hotel Lobby AI 运营 hotel-lobby.org，这是一项在站内将两张照片生成双人 AI 对唱视频的服务。本政策说明我们处理哪些信息、处理原因、与谁共享，以及您拥有的选择。联系我们：[support@hotel-lobby.org](mailto:support@hotel-lobby.org)。

## 照片与风格说明

当您点击预览或生成按钮时，两张照片会先在您的浏览器中压缩，然后连同可选的风格说明一起发送给我们的 AI 处理服务商（fal.ai），用于生成场景和视频。点击按钮之前，照片不会被上传。

- 我们 **不会** 在自己的服务器上保存您的原始照片。照片仅用于当次生成请求，并由 fal.ai 依据其数据条款处理。
- 风格说明在生成前会经过我们自己的过滤器以及由 Waffo 运营的自动化提示词安全扫描服务审核。送去扫描的只有说明文字，不包含照片，扫描服务也不会保存这些文字。
- 只能上传您本人或已获得其许可的人的照片，详见[《可接受使用政策》](/zh/acceptable-use-policy)。

## 生成的内容

场景图片和生成好的视频会被保存，方便您在 **我的视频** 中查看和下载。账户存续期间，视频保存在我们的云存储（Cloudflare R2）中。您可以随时要求我们删除某些视频或整个账户。

## 账户与使用信息

- **账户：** 邮箱地址、姓名和头像（如使用 Google 登录）以及登录会话。
- **使用记录：** 积分、生成历史、订单和支持工单。
- **技术数据：** IP 地址、浏览器和设备信息、大致语言、来源渠道和请求日志，用于运行和保护网站、防止滥用生成请求。
- **邮件：** 我们会发送事务性邮件，例如注册后的欢迎邮件，由我们的邮件服务商（Resend）投递。

## 支付

付款由我们的支付服务商或记录商户（目前为 PayPal）处理。他们会收到您输入的支付信息；我们看不到也不会保存您完整的银行卡或银行账户信息。我们会保留订单记录（金额、商品、状态及支付服务商的参考编号），用于记账、退款和防范欺诈。

## 数据分析

我们使用 Microsoft Clarity 了解访客如何使用网站。Clarity 会记录点击、滚动和页面浏览等交互，并可能生成会话回放和热力图。Clarity 默认会遮盖您在表单中输入的文字，并使用 Cookie 或类似技术。详情请参阅 [Microsoft 隐私声明](https://privacy.microsoft.com/zh-cn/privacystatement)。

## 与谁共享信息

我们只会与帮助我们运营服务的服务商共享信息，且仅限于实现相应目的所需：AI 处理（fal.ai）、提示词安全扫描（Waffo）、托管与存储（Cloudflare）、邮件投递（Resend）、支付（PayPal）和数据分析（Microsoft Clarity）。我们不会出售您的个人信息。在法律要求时我们可能披露信息，并会向有关部门报告儿童性虐待材料。

## 保留期限

账户存续期间，我们会保留账户信息和生成的视频。订单和支付记录按税务和会计义务要求的期限保留。服务器日志出于安全目的保留有限时间。您删除账户后，我们会在 30 天内删除您的视频和个人资料，法律要求保留的记录除外。

## 您的权利与选择

您可以用账户邮箱发送邮件至 [support@hotel-lobby.org](mailto:support@hotel-lobby.org)，查阅、更正或删除您的信息，或索取信息副本。在适用情况下，您也可以反对某些处理或撤回同意。视您所在地区而定，您可能有权向数据保护机构投诉。

## 儿童

账户仅限成年人使用。父母或法定监护人可以上传自己孩子的照片，用于健康的家庭内容，详见[《可接受使用政策》](/zh/acceptable-use-policy)。我们不会有意直接收集儿童的信息。

## 变更

当服务或数据处理方式发生变化时，我们可能更新本政策。页首日期为最新修订日期。
